module.exports = __webpack_public_path__ + "img/banner1.c9cc7653.png";